<template>
    <div class="root">
        <h4>Subscription</h4>
        <div v-if="!!value">
            <label><span>Stripe subscription id:</span><input disabled type="text" v-model="value.stripeSubscriptionId" /></label>
            <label>
                <span>Expiration date:</span><input disabled type="datetime-local" v-model="value.expiresAt" />
            </label>
            <label><span>Credits:</span><input type="number" disabled v-model="value.credits" /></label>
            <label><span>Additional credits:</span><input type="number" disabled v-model="value.additionalCredits" /></label>
            <label><span>Contact name:</span><input type="email" disabled v-model="value.contactName" /></label>
            <label><span>Contact email:</span><input type="email" disabled v-model="value.contactEmail" /></label>
            <div class="flex">
                <button v-on:click.stop="showAdditionalCreditsModal = true">Add credits</button>
                <button v-on:click.stop="showUpdateContactEmail = true">Update contact</button>
                <button v-on:click.stop="cancelPGSubscription()">Cancel Subscription</button>
            </div>
        </div>
        <button v-if="!value && !newPgSubscription" v-on:click.stop="newPgSubscription = {...defaultPgSubscription}">Add new</button>
        <div v-if="!!newPgSubscription && !value">
            <label><span>Stripe subscription ID:</span><input type="text" v-model="newPgSubscription.stripeSubscriptionId" /></label>
            <div v-if="errors && !!errors.StripeSubscriptionId" class="error">{{errors.StripeSubscriptionId}}</div>
            <label><span>Credits:</span><input type="number" v-model.number="newPgSubscription.credits" /></label>
            <div v-if="errors && !!errors.Credits" class="error">{{errors.Credits}}</div>
            <label><span>Expiry date:</span><input type="datetime-local" v-model="newPgSubscription.expiresAt" /></label>
            <div v-if="errors && !!errors.ExpiresAt" class="error">{{errors.ExpiresAt}}</div>
            <label><span>Contact name:</span><input type="text" v-model="newPgSubscription.contactName" /></label>
            <div v-if="errors && !!errors.ContactEmail" class="error">{{errors.ContactName}}</div>
            <label><span>Contact email:</span><input type="email" v-model="newPgSubscription.contactEmail" /></label>
            <div v-if="errors && !!errors.ContactEmail" class="error">{{errors.ContactEmail}}</div>
            <div>
                <button v-on:click.stop="newPgSubscription = null">Cancel</button>
                <button v-on:click.stop="addPGSubscription()">Save</button>
            </div>
        </div>
        <div class="modalBackground" v-if="showAdditionalCreditsModal">
            <div class="ModalForm">
                <div class="header">
                    <h2>Add additional credits</h2>
                </div>
                <div class="modalContent">
                    <label>Credits: <input type="number" v-model.number="additionalCredits" /></label>
                </div>
                <div class="modalActions">
                    <button v-on:click.stop="showAdditionalCreditsModal = false">Cancel</button>
                    <button v-on:click.stop="addAdditionalCredits(additionalCredits)">Add</button>
                </div>
            </div>
        </div>
        <div class="modalBackground" v-if="showUpdateContactEmail">
            <div class="ModalForm">
                <div class="header">
                    <h2>Update contact email</h2>
                </div>
                <div class="modalContent">
                    <label>Contact name: <input type="text" v-model="contactName" /></label>
                    <label>Contact email: <input type="email" v-model="contactEmail" /></label>
                </div>
                <div class="modalActions">
                    <button v-on:click.stop="showUpdateContactEmail = false">Cancel</button>
                    <button v-on:click.stop="updateContactEmail(contactName, contactEmail)">Update</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .flex {
        display: flex;
    }

    label {
        width: 400px;
        max-width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
    }

        label span {
            font-weight: bold;
        }

        label input {
            width: 150px;
        }

    .ModalForm {
        height: auto;
        width: 400px;
        top: 50px;
    }

    .header {
        padding: 15px;
    }

    .modalContent {
        padding: 15px;
    }

    .modalActions {
        display: flex;
        justify-content: end;
        padding: 15px;
    }

    h4, h2 {
        margin: 0;
    }

    .root {
        margin: 16px 0;
    }

    button:not(:first-of-type) {
        margin-left: 10px;
    }
</style>
<script>
    import $ from "jquery";
    export default {
        name: 'PgSubscription',
        props: ['value', 'roleId'],
        data: function () {
            var now = new Date();
            return {
                additionalCredits: 10,
                showAdditionalCreditsModal: false,
                showUpdateContactEmail: false,
                newPgSubscription: null,
                defaultPgSubscription: {
                    credits: 120,
                    expiresAt: new Date(now.setFullYear(now.getFullYear() + 1)).toISOString().slice(0, 16),
                },
                errors: null,
                contactEmail: this.value?.contactEmail,
                contactName: this.value?.contactName,
            }
        },
        methods: {
            "addAdditionalCredits": function (credits) {
                var myComponent = this;

                $.ajax({
                    type: 'POST',
                    url: `Roles/${this.roleId}/PGSubscription/AddCredits`,
                    data: JSON.stringify(credits),
                    contentType: 'application/json',
                }).then(subscription => {
                    myComponent.$emit('input', {
                        ...subscription,
                        expiresAt: subscription.expiresAt.slice(0, 16),
                    });
                    alert(`${credits} additional credits were added`);
                    myComponent.showAdditionalCreditsModal = false;
                }, function () {
                    alert(`An error occurred while adding additional credits`);
                });
            },
            "addPGSubscription": function () {
                var myComponent = this;
                if (!myComponent.newPgSubscription) {
                    return;
                }
                $.ajax({
                    type: 'PUT',
                    url: `Roles/${this.roleId}/PGSubscription`,
                    data: JSON.stringify(this.newPgSubscription),
                    contentType: 'application/json',
                }).then(subscription => {
                    myComponent.$emit('input', {
                        ...subscription,
                        expiresAt: subscription.expiresAt.slice(0, 16),
                    });
                    myComponent.newPgSubscription = null;
                    myComponent.errors = null;
                }, function (error) {
                    var message = "";
                    if (error.responseJSON?.errors) {
                        myComponent.errors = {
                            ...error.responseJSON.errors
                        };
                    } else {
                        message = error.responseText;
                    }
                    alert(`An error occurred while creating the subscription. ${message}`);
                });
            },
            "cancelPGSubscription": function () {
                var myComponent = this;
                $.ajax({
                    type: 'DELETE',
                    url: `Roles/${this.roleId}/PGSubscription`,
                    contentType: 'application/json',
                }).then(() => {
                    myComponent.$emit('input', null);
                }, error => {
                    alert(error.responseText);
                });
            },
            "updateContactEmail": function (name, email) {
                var myComponent = this;
                $.ajax({
                    type: 'POST',
                    url: `Roles/${this.roleId}/PGSubscription/Contact`,
                    contentType: 'application/json',
                    data: JSON.stringify({
                        contactEmail: email.trim(),
                        contactName: name.trim(),
                    }),
                }).then(subscription => {
                    console.log(subscription)
                    myComponent.$emit('input', {
                        ...subscription,
                        expiresAt: subscription.expiresAt.slice(0, 16),
                    });
                    myComponent.showUpdateContactEmail = false;
                }, error => {
                    alert(error.responseText);
                });
            },
        }
    }
</script>